export { default } from './ContentHalf';
